import translateString from './translator';

/**
 * Creates a link DOM node for the imprint link and appends it to the provided container.
 *
 * @param {CMP} cmpObject
 * @param {HTMLElement} container
 * @param {string} linkCssClass
 */
const createImprintLink = (cmpObject, container, linkCssClass = 'footer-secondary-nav__link') => {
  const imprintLinkContainer = document.createElement('li');

  // primary footer menus
  if (container.classList.contains('footer-nav__list')) {
    imprintLinkContainer.classList.add('footer-nav__item');
  } else { // privacy footer menus
    imprintLinkContainer.classList.add('menu-item', 'footer-secondary-nav__item');
  }

  const consentLink = document.createElement('a');
  consentLink.classList.add(linkCssClass);
  consentLink.id = 'unified-cmp-footer-link';
  consentLink.href = '/imprint/';
  consentLink.target = '_blank';
  consentLink.text = 'Imprint';

  imprintLinkContainer.append(consentLink);
  container.append(imprintLinkContainer);
};

/**
 * Create a link DOM node for the CMP link toggle
 *
 * @param cmpObject
 * @param container
 * @param linkCssClass
 * @param elementId
 */
const createCmpLinkToggle = (cmpObject, container, linkCssClass = 'footer-secondary-nav__link', elementId = 'unified-cmp-footer-link') => {
  const consentContainer = document.createElement('li');

  // primary footer menus
  if (container.classList.contains('footer-nav__list')) {
    consentContainer.classList.add('footer-nav__item');
  } else { // privacy footer menus
    consentContainer.classList.add('menu-item', 'footer-secondary-nav__item');
  }

  const consentLink = document.createElement('a');
  consentLink.classList.add('unified-cmp-link-toggle');
  consentLink.classList.add(linkCssClass);

  // assign the CMP link ID - there are some instances where we do not want an ID
  if (elementId.length > 0) {
    consentLink.id = elementId;
  }

  // eslint-disable-next-line no-script-url
  consentLink.href = 'javascript: window.s1.CmpWrapper.showCmpBanner()';

  if (cmpObject.gdprApplies || cmpObject.lgpdApplies) {
    consentLink.text = translateString('Change my Consent');
  } else {
    consentLink.text = translateString('Do not Sell my Info');
  }

  consentContainer.append(consentLink);
  container.append(consentContainer);
};

/**
 * Add Privacy Consent link in the footer of the page.
 */
const injectCmpFooterPrivacyLink = () => {
  const cmp = window.s1.CmpWrapper;

  if (cmp.gdprApplies || cmp.lgpdApplies || cmp.ccpaApplies) {
    console.log('CMP experience detected, injecting footer links via unified footer JS.');
    // site footers
    const privacyFooter = document.querySelector('ul.footer-secondary-nav__list');
    if (privacyFooter) {
      createCmpLinkToggle(cmp, privacyFooter);
    }

    // custom CMP link locations - this class should be added to WP menus when the menu is called
    // doing so will inject CMP toggle link just like the footer code above
    const cmpMenus = document.querySelectorAll('.cmp__menu');
    if (typeof cmpMenus !== 'undefined' && cmpMenus !== null) {
      cmpMenus.forEach((menu) => {
        createCmpLinkToggle(cmp, menu, 'cmp__link', '');
      });
    }
  }

  // Imprint logic (https://docs.google.com/document/d/103LjZnsx67_HXYTXHVqoHobI60XGx7pjDzELc3NogdI/edit#)
  if (cmp.imprintApplies) {
    // site footers
    const privacyFooter = document.querySelector('ul.footer-secondary-nav__list') || document.querySelector('.footer-nav__list ul');
    if (privacyFooter) {
      createImprintLink(cmp, privacyFooter);
    }
  }
};

export {
  // eslint-disable-next-line import/prefer-default-export
  injectCmpFooterPrivacyLink
};
